module.exports = __webpack_public_path__ + "img/case_6.dcdf051b.png";